import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  idvFail: () => i18n.t(i18nKeys.idv_failure),
  idvFailureSubtext1: () => i18n.t(i18nKeys.idv_failure_subtext1),
  idvFailureSubtext2: () => i18n.t(i18nKeys.idv_failure_subtext2),
  idvFailureSubtext3: () => i18n.t(i18nKeys.idv_failure_subtext3),
  idvFailureFAQ: () => i18n.t(i18nKeys.idv_failure_faq),
  contactSupport: () => i18n.t(i18nKeys.contact_support),
  idvNeedsReview: () => i18n.t(i18nKeys.idv_needs_review),
  idvNeedsReviewSubtext: () => i18n.t(i18nKeys.idv_needs_review_subtext),
  viewFAQ: () => i18n.t(i18nKeys.idv_view_faq),
  idvComplete: () => i18n.t(i18nKeys.idv_complete),
  idvCompleteSubtext: () => i18n.t(i18nKeys.idv_complete_subtext),
  continue: () => i18n.t(i18nKeys.idv_continue),
}
